import React from "react";
import SideMenu from "components/sidemenu/SideMenu";
import TopBar from "components/topBar/TopBar";
import { Outlet } from "react-router-dom";

const DashboardLayout = ({
    joyrideStart,
    setActiveCountsTab,
    activeCountsTab,
}) => {
    return (
        <div className="bg-white dark:bg-[#0D1822] h-screen flex flex-col ">
            <TopBar />
            <div className="flex flex-grow dark:bg-[#0D1822]">
                <SideMenu
                    joyrideStart={joyrideStart}
                    setActiveCountsTab={setActiveCountsTab}
                    activeCountsTab={activeCountsTab}
                />
                <div className="flex-grow ml-[26%] pr-10 overflow-y-auto relative">
                    <div className="pb-32">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardLayout;
